export default __webpack_public_path__ + "static/media/TheQuarry.0a9cef8c.jpg";